import _ from 'lodash';

export default function ObjectUtilService() {
  this.mergeInto = mergeInto;

  function mergeInto(from, into) {
    _.forOwn(from, function (value, key) {
      var exists = into.hasOwnProperty(key);
      if (!exists) {
        into[key] = value;
      }
    });

    return into;
  }
}

export const lowerCaseKeysObject = (obj = {}) =>
  Object.keys(obj).reduce((newObj, key) => {
    newObj[key.toLowerCase()] = obj[key];
    return newObj;
  }, {});
